module.exports = __webpack_public_path__ + "img/aizong.d26df5d5.png";